import locale from 'meta-ui/lib/locale/lang/pt';
import pt from 'govmo-common/src/locales/pt.json';
import merge from 'lodash/merge';
import AddressComponent from 'common/components/Address/locales/pt.json';
import MessagePlugin from 'common/plugins/message/locales/pt.json';
export default {
  ...MessagePlugin,
  ...AddressComponent,
  ...merge(locale, {
    el: {
      transfer: {
        filterPlaceholder: '請輸入搜索內容',
      },
    },
  }),
  ...pt,
};
